import React from 'react';
import { Card, ExamTable } from 'components';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { connect } from 'react-redux';
import { IExam } from '../../api/ApiClient';
import { push } from 'connected-react-router';
import { IPaginationData } from 'components/Pagination/Pagination';
import { useLocalErrorHandler } from 'hooks';
import inviteLink from 'components/assets/svg/invite_icon.svg';
import styles from './ParticipationRequestsContainer.module.scss';

const ParticipationRequestsContainer = ({
    setErrorHandler, onFetchRequests, onPush, requestsList, apiError,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const [processing, setProcessing] = React.useState(false);

    React.useEffect(() => {
        const fetch = async () => {
            setProcessing(true);
            await onFetchRequests({
                page: undefined,
                pageSize: undefined,
                sortField: undefined,
                sortOrder: undefined,
            });
            setProcessing(false);
        };

        fetch();
    }, []);

    const handleChooseExam = (examId: string) => {
        onPush(`/exam-invite/${examId}`);
    };

    const getExamData = (exam: IExam) => ({
        ...exam,
        name: exam.qualificationTitle,
        status: undefined,
    });

    const handleChangePagination = (newPagination: IPaginationData) => {
        onFetchRequests({
            page: newPagination.page,
            pageSize: newPagination.perPage,
            sortField: undefined,
            sortOrder: undefined,
        });
    };

    return (
        <Card
          withoutPadding
          title="Запросы на участие"
          category="Список запросов от АК на ваше участие в проведении аккредитаций"
          apiError={apiError}
          showLoader={processing}
        >
            {requestsList && requestsList.items
                ? (
                    <ExamTable
                      header={HEADER}
                      tableRows={requestsList.items.map(getExamData)}
                      onChooseExam={handleChooseExam}
                      pagination={requestsList}
                      onChangePagination={handleChangePagination}
                    />
                )
                : (
                    <div className={styles.emptyBody}>
                        <img src={inviteLink} alt="inviteLink" />
                        <h4>
                            Нет запросов на участие
                        </h4>
                        <span>
                            Здесь будут отображаться запросы от АК на ваше участие в проведении аккредитаций
                        </span>
                    </div>
                )
            }
        </Card>
    );
};

const HEADER = [
    'Дата и время',
    'Специальность',
];

const mapState = (state: IRootState) => ({
    requestsList: state.requests.requestsList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    onFetchRequests: dispatch.requests.fetchRequests,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(ParticipationRequestsContainer);

type connectedProps = ReturnType<typeof mapDispatch> & ReturnType<typeof mapState>;
type Props = connectedProps;
